import { Injectable } from '@angular/core';

@Injectable()
export class PlatformService {
  public isMobile(): boolean {
    return !!(navigator as any).app;
  }
}



// WEBPACK FOOTER //
// ./src/modules/core/services/platform-service/platform-service.ts